export default __webpack_public_path__ + "static/media/flag-martinique.8cf51d50.svg";